module.exports = __webpack_public_path__ + "static/media/playlistFolder.fb375a72.svg";